import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const Times = createSvgIcon(
  () => (
    <path d="M18.8721 15.5518L28.9307 5.59082L30.9814 3.54004C31.2744 3.24707 31.2744 2.75879 30.9814 2.36816L28.833 0.219727C28.4424 -0.0732422 27.9541 -0.0732422 27.6611 0.219727L15.6494 12.3291L3.54004 0.219727C3.24707 -0.0732422 2.75879 -0.0732422 2.36816 0.219727L0.219727 2.36816C-0.0732422 2.75879 -0.0732422 3.24707 0.219727 3.54004L12.3291 15.5518L0.219727 27.6611C-0.0732422 27.9541 -0.0732422 28.4424 0.219727 28.833L2.36816 30.9814C2.75879 31.2744 3.24707 31.2744 3.54004 30.9814L15.6494 18.8721L25.6104 28.9307L27.6611 30.9814C27.9541 31.2744 28.4424 31.2744 28.833 30.9814L30.9814 28.833C31.2744 28.4424 31.2744 27.9541 30.9814 27.6611L18.8721 15.5518Z" />
  ),
  '0 0 32 32'
);
